import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconMinusStyle0 = gravityIconIndividualCss;

const GravityIconMinus = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '0b09d5cd0bd9f475eb8b1d442dc8ef5d9140b3bb', color: this.color, size: this.size }, h("svg", { key: 'b3e7c6016cb167fed3bfcb9123df21260e21f77b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("rect", { key: '0240f0fb15c5db6640ac326648bbddea099dc8fd', x: "4.5", y: "10.25", width: "13", height: "1.5", rx: ".25", fill: "currentColor" }))));
    }
};
GravityIconMinus.style = GravityIconMinusStyle0;

export { GravityIconMinus as gravity_icon_minus };

//# sourceMappingURL=gravity-icon-minus.entry.js.map